import { render } from "./topicManager.vue?vue&type=template&id=c46e83ba&scoped=true"
import script from "./topicManager.vue?vue&type=script&lang=js"
export * from "./topicManager.vue?vue&type=script&lang=js"

import "./topicManager.vue?vue&type=style&index=0&id=c46e83ba&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c46e83ba"]])

export default __exports__